import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";

export function Header({ onBook }: { onBook: () => void }) {
  const [navOpen, setNavOpen] = useState(false);
  const closeNav = () => setNavOpen(false);

  return (
    <header className="header">
      <div className="container">
        <div className="header-inner">
          <Link to="/" className="header-logo" onClick={closeNav}>
            <img src="/logo-master.png" alt="" />
            <span>
              Automate<em>828</em>
            </span>
          </Link>
          <nav
            className={`header-nav${navOpen ? " open" : ""}`}
            id="nav"
            aria-label="Primary"
          >
            <Link to="/#services" onClick={closeNav}>What we do</Link>
            <Link to="/#process" onClick={closeNav}>How we work</Link>
            <Link to="/pricing" onClick={closeNav}>Pricing</Link>
            <Link to="/#mail" onClick={closeNav}>Print &amp; mail</Link>
            <Link to="/#scenarios" onClick={closeNav}>Scenarios</Link>
            <Link to="/#local" onClick={closeNav}>The 828</Link>
          </nav>
          <div className="header-cta">
            <span className="header-area-code">828 · WNC</span>
            <button className="btn btn-primary" onClick={onBook}>
              Book a free intro
            </button>
            <button
              className="menu-toggle"
              id="nav-toggle"
              aria-controls="nav"
              aria-expanded={navOpen}
              aria-label={navOpen ? "Close menu" : "Open menu"}
              onClick={() => setNavOpen((v) => !v)}
            >
              <Menu size={20} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
